<template>
  <div class="container">
    <img :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-head.png?' + random()" alt="" />
    <img :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-intr.png?' + random()" alt="" />
    <img class="btn" @click="toReward" :src="'https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/activity-btn.png?' + random()" alt="" />
  </div>
</template>
<script>
import { Dialog } from "vant"
export default {
  name: "activity",
  components: {},
  data() {
    return {
      uId: "",
      hasParticipate: false
    }
  },
  created() {
    document.title = "百万奖金池，有“机”你就来！"
    let params = this.$route.query
    this.uId = params.uId
    this.hasParticipate = params.hasParticipate == "true"
    if (this.hasParticipate) {
      this.$router.push({
        path: "/reward",
        query: {
          uId: this.uId,
          hasParticipate: "true"
        }
      })
    }
  },
  methods: {
    toReward() {
      const data = {
        uid: this.uId,
        eqpSource: 3,
        closeToast: true
      }
      this.$api
        .activitySignUp(data)
        .then((res) => {
          if (res.data.code == 0) {
            Dialog.alert({
              title: "报名成功！",
              confirmButtonText: "我知道了",
              confirmButtonColor: "",
              message: "<div>送你200元提现额度,</div><div>上传车源即可申请提现~</div>"
            }).then(() => {
              this.$router.push({
                path: "/reward",
                query: {
                  uId: this.uId,
                  hasParticipate: "true"
                }
              })
            })
          } else if (res.data.code == "0001") {
            Dialog.alert({
              title: "报名失败！",
              confirmButtonText: "我知道了",
              confirmButtonColor: "",
              message: "活动已结束~"
            }).then(() => {})
          } else if (res.data.code == "0002") {
            Dialog.alert({
              title: "",
              confirmButtonText: "我知道了",
              confirmButtonColor: "",
              message: "您已报名过"
            }).then(() => {
              this.$router.push({
                path: "/reward",
                query: {
                  uId: this.uId,
                  hasParticipate: "true"
                }
              })
            })
          } else if (res.data.code == "0003") {
            Dialog.alert({
              title: "报名失败！",
              confirmButtonText: "我知道了",
              confirmButtonColor: "",
              message: "活动参与人数已满100人"
            }).then(() => {})
          } else {
            alert(res.data.msg)
          }
        })
        .catch((err) => {
          // alert(err);
        })
    },
    random() {
      return Math.floor(Math.random() * 100 + 1)
    }
  },
  watch: {}
}
</script>
<style lang="scss">
.container {
  .van-cell {
    background: #ffffff;
    margin-top: 0;
  }
  .van-field__label {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #ff4a43;
  box-sizing: border-box;
  position: relative;
  font-family: PingFangSC-Semibold, PingFang SC;
  img {
    width: 100%;
    margin-top: -3px;
  }
  .btn {
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
</style>
